import { flatten, sum } from "lodash";

const CardPayment = () => {
    const main = document.getElementById('checkout');
    if (!main) {
        return;
    }
    const billingPrefix = '#billing-';
    const shippingPrefix = '#shipping-';

    const element = {
        paymentMethodInput: $('input[name="checkout_payment_method"]'),
        checkboxTerms: $("#checkout-terms"),
        formCheckout: $("#form-checkout"),
        btnCheckout: $("#btn-checkout"),
        billing: {
            id: $(`${billingPrefix}id`),
            existingAddress: $(`${billingPrefix}address`),
            firstName: $(`${billingPrefix}first_name`),
            lastName: $(`${billingPrefix}last_name`),
            company: $(`${billingPrefix}company`),
            country: $(`${billingPrefix}country`),
            city: $(`${billingPrefix}city`),
            state: $(`${billingPrefix}state`),
            streetAddress: $(`${billingPrefix}street_address`),
            zip: $(`${billingPrefix}zip`),
            email: $(`${billingPrefix}email`),
            phone: $(`${billingPrefix}phone`),
        },
        shipping: {
            id: $(`${shippingPrefix}id`),
            existingAddress: $(`${shippingPrefix}address`),
            firstName: $(`${shippingPrefix}first_name`),
            lastName: $(`${shippingPrefix}last_name`),
            company: $(`${shippingPrefix}company`),
            country: $(`${shippingPrefix}country`),
            city: $(`${shippingPrefix}city`),
            state: $(`${shippingPrefix}state`),
            streetAddress: $(`${shippingPrefix}street_address`),
            zip: $(`${shippingPrefix}zip`),
            email: $(`${shippingPrefix}email`),
            phone: $(`${shippingPrefix}phone`),
        },
        billingDifferentAddress: $('#billing-different-address'),
        billingDifferentAddressValue: $('#billing-diff-address'),
        errorsGate: $("#errors-gate"),
        errorsGateContent: $("#errors-gate-content"),
        checkoutAddressError: $('#checkout-address-error')
    };
    let paymentMethod = "paypal";
    let stripeKey;

    const isAddressFieldsValid = () => {
        let fields = [
            element.shipping.firstName,
            element.shipping.lastName,
            element.shipping.country,
            element.shipping.city,
            element.shipping.state,
            element.shipping.streetAddress,
            element.shipping.zip,
            element.shipping.email,
            element.shipping.phone,
        ];
        if (element.billingDifferentAddressValue.val()) {
            fields = fields.concat([
                element.billing.firstName,
                element.billing.lastName,
                element.billing.country,
                element.billing.city,
                element.billing.state,
                element.billing.streetAddress,
                element.billing.zip,
                element.billing.email,
                element.billing.phone,
            ]);
        }

        const errorsCheck = fields.map((field) => field.val().length > 0 ? 0 : 1);

        if (sum(errorsCheck) !== 0) {
            element.checkoutAddressError.show();

            return false;
        }

        return true
    }

    element.btnCheckout.prop('disabled', true);

    axios.post('/orders/checkout/card/key')
        .then(response => {
            stripeKey = response.data.key;
        });

    element.paymentMethodInput.change(function (e) {
       paymentMethod = e.target.value;
    });

    element.checkboxTerms.change(function (e) {
        const checked = e.target.checked;

        element.btnCheckout
            .prop('disabled', !checked)
            .css('cursor', checked ? 'pointer' : 'not-allowed');
    });

    element.btnCheckout.click(function (e) {
        e.preventDefault();

        if (!isAddressFieldsValid()) {
            return;
        }

        if (paymentMethod === "paypal") {
            element.formCheckout.trigger('submit');
        } else if (paymentMethod === "card" && stripeKey) {
            const data = {
                'billing-diff-address': element.billingDifferentAddressValue.val(),
                'billing-id': element.billing.id.val(),
                'shipping-id': element.shipping.id.val(),

                'shipping-first_name': element.shipping.firstName.val(),
                'shipping-last_name': element.shipping.lastName.val(),
                'shipping-company': element.shipping.company.val(),
                'shipping-country': element.shipping.country.val(),
                'shipping-city': element.shipping.city.val(),
                'shipping-state': element.shipping.state.val(),
                'shipping-street_address': element.shipping.streetAddress.val(),
                'shipping-zip': element.shipping.zip.val(),
                'shipping-email': element.shipping.email.val(),
                'shipping-phone': element.shipping.phone.val(),

                'billing-first_name': element.billing.firstName.val(),
                'billing-last_name': element.billing.lastName.val(),
                'billing-company': element.billing.company.val(),
                'billing-country': element.billing.country.val(),
                'billing-city': element.billing.city.val(),
                'billing-state': element.billing.state.val(),
                'billing-street_address': element.billing.streetAddress.val(),
                'billing-zip': element.billing.zip.val(),
                'billing-email': element.billing.email.val(),
                'billing-phone': element.billing.phone.val(),
            };

            const stripe = Stripe(stripeKey);

            element.errorsGate.addClass('d-none');
            element.errorsGateContent.empty();
            axios.post('/orders/checkout/card', data)
                .then(response => {
                    const session = response.data;
                    console.log(session);
                    return stripe.redirectToCheckout({ sessionId: session.id });
                })
                .then(result => {
                    // Redirect to checkout error
                    console.log(result);

                    if (result.error) {
                        alert(result.error.message);
                    }
                })
                .catch(error => {
                    if (error.response.status && error.response.status === 422) {
                        const errors = error.response.data.errors;

                        const messages = flatten(Object.keys(errors).map((key) => errors[key]));

                        console.log(messages);
                        messages.forEach((message) => {
                            element.errorsGateContent.append(`${message}<br/>`);
                        });

                        element.errorsGate.removeClass('d-none');
                    }

                    throw new Error(error); // Useful to let sentry catch the bug
                });
        }
    });
};

$(() => {
    CardPayment();
})
